import { message, notification } from 'ant-design-vue';

// Keep feedback inside the active fullscreen element without requesting or exiting fullscreen.
let feedbackHost;
function getFeedbackHost() {
  if (!feedbackHost) {
    feedbackHost = document.createElement('div');
    feedbackHost.className = 'app-feedback-host';
  }
  const parent = document.fullscreenElement || document.webkitFullscreenElement || document.body;
  if (feedbackHost.parentNode !== parent) parent.appendChild(feedbackHost);
  return feedbackHost;
}
export function setupFeedback() {
  message.config({ getContainer: getFeedbackHost, top: '24px', duration: 3, maxCount: 3 });
  notification.config({ getContainer: getFeedbackHost });
  document.addEventListener('fullscreenchange', getFeedbackHost);
  document.addEventListener('webkitfullscreenchange', getFeedbackHost);
}
export const feedback = {
  success: (content) => message.success({ content, duration: 3 }),
  info: (content) => message.info({ content, duration: 3 }),
  warning: (content) => message.warning({ content, duration: 4 }),
  error: (content) => message.error({ content, duration: 6 }),
};
